'use client';

import { PropsWithClassname } from '@/app/types';
import classNames from 'classnames';

import { useTranslation } from 'react-i18next';

import Button, { ButtonHTMLTag, ButtonStyle } from '@/app/components/Button/Button';

interface DonateBoxCommercialFinishedProps extends PropsWithClassname {
  onShareButtonClick: () => void;
  onShowRewardsClick?: () => void;
}

const DonateBoxCommercialFinished = ({
  onShareButtonClick,
  className,
  onShowRewardsClick,
}: DonateBoxCommercialFinishedProps) => {
  const { t } = useTranslation();

  return (
    <div className={classNames(className, 'flex lg:flex-col')}>
      <Button
        style={ButtonStyle.PRIMARY}
        className="grow text-center mr-[16px] lg:mr-0 lg:mb-[16px] lg:px-[24px] lg:py-[20px]"
        tagSpecificProps={{ htmlTag: ButtonHTMLTag.BUTTON, onClick: onShowRewardsClick }}
      >
        {t('components.DonateBox.showRewards')}
      </Button>
      <Button
        style={ButtonStyle.PRIMARY_OUTLINED}
        className="grow-0 lg:px-[24px] lg:py-[20px]"
        tagSpecificProps={{ htmlTag: ButtonHTMLTag.BUTTON, onClick: onShareButtonClick }}
      >
        {t('components.DonateBox.share')}
      </Button>
    </div>
  );
};

export default DonateBoxCommercialFinished;
